<template>
    <div class="declaration">
        <el-dialog
            :visible.sync="dialogVisible"
            title="合格投资者承诺"
            :show-close="false"
            :close-on-click-modal="false"
            center
            width="600px"
            v-on:closed="dialogVisible = false"
        >
            <div class="content">
                <div class="text-content">
                    <span>
                        {{
                            $const.COMPANY
                        }}谨遵《中华人民共和国证券投资基金法》及《私募投资基金监督管理暂行办法》、《私募投资基金募集行为管理办法》、《证券期货经营机构私募资产管理业务管理办法》、《证券期货经营机构私募资产管理计划运作管理规定》，只向特定的合格投资者宣传推介相关私募投资基金及资产管理计划。
                    </span>
                    <span>
                        若您有意查看和购买{{ $const.COMPANY
                        }}{{
                            $cache.getCompanyInfoParam("10102005") == "1" ? "" : "代销"
                        }}的相关私募投资基金及资产管理计划，请先确认您符合法规规定的“合格投资者”标准。
                    </span>
                    <span>
                        私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人:
                    </span>
                    <span>(一)净资产不低于1000万元的单位</span>
                    <span>
                        (二)金融资产不低于300万元或者最近三年个人年均收入不低于50 万元的个人。
                    </span>
                    <span>
                        资产管理产品的投资者分为不特定社会公众和合格投资者两大类。合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只资产管理产品不低于一定金额且符合下列条件的自然人和法人或者其他组织。
                    </span>
                    <span>
                        (一)具有2年以上投资经历，且满足以下条件之一：家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或者近3年本人年均收入不低于40万元。
                    </span>
                    <span>(二)最近1年末净资产不低于1000万元的法人单位。</span>
                    <span>(三)金融管理部门视为合格投资者的其他情形。</span>
                </div>
                <div v-if="showForm">
                    <el-form
                        ref="cardForm"
                        :model="cardForm"
                        :rules="rules"
                        label-width="100px"
                        inline-message
                        v-on:submit.native.prevent
                    >
                        <el-form-item
                            label="证件类型:"
                            :required="true"
                            prop="certificatetype"
                            class="icon-select"
                        >
                            <el-select
                                v-model="cardForm.certificatetype"
                                style="width: 450px"
                                placeholder="请选择证件类型"
                            >
                                <el-option
                                    v-for="item in certTypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="证件号码:" :required="true" prop="certificateno">
                            <el-input
                                v-model.trim="cardForm.certificateno"
                                placeholder="请输入证件号码"
                            />
                        </el-form-item>
                        <el-form-item label="真实姓名:" :required="true" prop="custname">
                            <el-input
                                v-model.trim="cardForm.custname"
                                placeholder="请输入真实姓名"
                            />
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer align-c">
                    <el-button v-on:click="back">返回</el-button>
                    <el-button type="primary" v-on:click="confirm">我承诺符合以上标准</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import userApi from "@/api/user";

export default {
    name: "Declaration",
    props: {
        visible: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            company: {},
            showForm: false, // 输入信息
            certTypes: [], // 证件类型
            cardForm: {
                certificatetype: "",
                certificateno: "",
                custname: ""
            },
            rules: {
                certificatetype: [
                    {
                        required: true,
                        message: "请选择证件类型",
                        trigger: "blur"
                    }
                ],
                certificateno: [
                    {
                        required: true,
                        message: "请输入证件号码",
                        trigger: "blur"
                    }
                ],
                custname: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
        }
    },
    mounted() {
        this.certTypes = this.$cache.getDict("130007");
        this.showForm = !this.$cache.getBinded();
    },
    methods: {
        back() {
            this.dialogVisible = false;
            this.$router.push({ name: "home" });
        },
        confirm() {
            if (this.$cache.getBinded()) {
                // 已开户
                this.midBusiness();
            } else {
                // 未开户
                this.$refs["cardForm"].validate((valid) => {
                    if (valid) {
                        this.noOpen();
                    } else {
                        this.$errorScroll();
                    }
                });
            }
        },
        // 已开户声明
        async midBusiness() {
            const userInfo = this.$cache.getUser();
            this.dialogVisible = false;
            if (userInfo.accreditedinvestor && userInfo.accreditedinvestor == "0") {
                this.$util.showMessageBox(
                    this,
                    "合格投资者未认证提示",
                    "根据监管要求，进行该类产品投资前需完成私募合格投资者认证,是否认证？",
                    "去认证",
                    "先看看产品",
                    function () {
                        // 去认证
                    },
                    function () {}
                );
                return;
            }
            const res = await userApi.midBusiness0BE({
                certificateno: userInfo.certificateno,
                custname: userInfo.custname,
                certificatetype: userInfo.certificatetype,
                accreditedinvestor: userInfo.accreditedinvestor
            });
            if (res.error) {
                return;
            }
            userInfo.disclaimersignflag = "1";
            this.$store.dispatch("setInfo", userInfo);
            this.dialogVisible = false;
            this.$emit("refresh-list");
        },
        // 未开户声明
        async noOpen() {
            if (this.cardForm.certificatetype === "00") {
                const res = await userApi.identifyVerification({
                    certificateno: this.cardForm.certificateno,
                    custname: this.cardForm.custname
                });
                if (res.error) {
                    this.$message.warning(res.error.message);
                    return;
                }
            }
            const userInfo = this.$cache.getUser();
            const res = await userApi.noOpenDisclaimersignTempHandler({
                invtp: "1",
                certificateno: this.cardForm.certificateno,
                custname: this.cardForm.custname,
                disclaimersignflag: "1", // 合格投资者声明 0-未声明 1- 已声明
                certificatetype: this.cardForm.certificatetype,
                acceptmethod: this.$util.getConfig().systemtype,
                custnoex: userInfo.userCode, // 和讯用户id
                accreditedinvestor: "3", // 合格投资者类型 字典120195( 1-私募合格投资者 2-资管合格投资者 3-私募与资管合格投资者)
                mobileno: userInfo.mobileno || ""
            });
            if (res.error) {
                return;
            }
            userInfo.disclaimersignflag = "1";
            userInfo.certificatetype = this.cardForm.certificatetype;
            userInfo.certificateno = this.cardForm.certificateno;
            userInfo.custname = this.cardForm.custname;
            this.$store.dispatch("setInfo", userInfo);
            this.dialogVisible = false;
            this.$emit("refresh-list");
            if (userInfo.riskexpired == "1") {
                this.$router.push({ name: "risk" });
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.declaration {
    .content {
        .text-content {
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;
        }
    }
    .el-form-item__error {
        position: absolute;
        top: 100%;
        left: 0;
    }
    .el-form-item__error--inline {
        position: absolute;
        top: 100%;
        left: 0;
    }
}
</style>
